export const uniqueVehicleLocations = (userVehicle, place) => userVehicle[place - 1].userVehicleId

export const dynamicVehicleLocationsDesktop = (noOfVehicles, userVehicle) => {
  const initialLayout = [
    `'ActiveVehicle Vehicle${uniqueVehicleLocations(userVehicle, 2)}'`,
    `'ActiveVehicle Vehicle${uniqueVehicleLocations(userVehicle, 3)}'`
  ]

  for (let iteration = 3; iteration <= noOfVehicles; iteration += 2) {
    if (iteration === noOfVehicles - 1) {
      if (noOfVehicles % 2 === 0) {
        initialLayout.push(`'Vehicle${userVehicle[iteration].userVehicleId} EmptyVehiclePlaceholder'`)
      } else {
        initialLayout.push(`'Vehicle${userVehicle[iteration].userVehicleId} Vehicle${userVehicle[iteration + 1].userVehicleId}'`)
        initialLayout.push(`${'"EmptyVehiclePlaceholder ."'}`)
      }
    }

    if (iteration < noOfVehicles && (iteration !== noOfVehicles - 1)) {
      initialLayout.push(`'Vehicle${userVehicle[iteration].userVehicleId} Vehicle${userVehicle[iteration + 1].userVehicleId}'`)
    }

    if (iteration === noOfVehicles) {
      initialLayout.push(`${'"EmptyVehiclePlaceholder ."'}`)
    }
  }

  const finalString = initialLayout.join(' ')
  return finalString
}

export const dynamicVehicleLocationsLaptopMobile = (noOfVehicles, userVehicle) => {
  const initialLayout = [
    '\'ActiveVehicle\'',
    `'Vehicle${uniqueVehicleLocations(userVehicle, 2)}'`,
    `'Vehicle${uniqueVehicleLocations(userVehicle, 3)}'`
  ]

  for (let iteration = 3; iteration <= noOfVehicles; iteration += 1) {
    if (iteration === noOfVehicles) {
      initialLayout.push('\'EmptyVehiclePlaceholder\'')
    } else {
      initialLayout.push(`'Vehicle${userVehicle[iteration].userVehicleId}'`)
    }
  }

  const finalString = initialLayout.join(' ')
  return finalString
}

export const setDesktopLayoutSequence = (noOfVehicles, userVehicle) => {
  switch (noOfVehicles) {
    case 0:
      return `
        'EmptyActiveVehiclePlaceholder'
        'EmptyActiveVehiclePlaceholder'
      `
    case 1:
      return `
        'ActiveVehicle EmptyVehiclePlaceholder'
        'ActiveVehicle . '
      `
    case 2:
      return `
        'ActiveVehicle Vehicle${uniqueVehicleLocations(userVehicle, 2)}'
        'ActiveVehicle EmptyVehiclePlaceholder'
      `
    case 3:
      return `
        'ActiveVehicle Vehicle${uniqueVehicleLocations(userVehicle, 2)}'
        'ActiveVehicle Vehicle${uniqueVehicleLocations(userVehicle, 3)}'
        'EmptyVehiclePlaceholder .'
      `
    default:
      return `${dynamicVehicleLocationsDesktop(noOfVehicles, userVehicle)}`
  }
}

export const setLaptopLayoutSequence = (noOfVehicles, userVehicle) => {
  switch (noOfVehicles) {
    case 0:
      return `
        'EmptyActiveVehiclePlaceholder'
        'EmptyActiveVehiclePlaceholder'
      `
    case 1:
      return `
        'ActiveVehicle'
        'EmptyVehiclePlaceholder'
      `
    case 2:
      return `
        'ActiveVehicle'
        'Vehicle${uniqueVehicleLocations(userVehicle, 2)}'
        'EmptyVehiclePlaceholder'
      `
    case 3:
      return `
        'ActiveVehicle'
        'Vehicle${uniqueVehicleLocations(userVehicle, 2)}'
        'Vehicle${uniqueVehicleLocations(userVehicle, 3)}'
        'EmptyVehiclePlaceholder'
      `
    default:
      return `${dynamicVehicleLocationsLaptopMobile(noOfVehicles, userVehicle)}`
  }
}

export const setMobileLayoutSequence = (noOfVehicles, userVehicle) => {
  switch (noOfVehicles) {
    case 0:
      return `
        'EmptyActiveVehiclePlaceholder'
      `
    case 1:
      return `
        'ActiveVehicle'
        'EmptyVehiclePlaceholder'
      `
    case 2:
      return `
        'ActiveVehicle'
        'Vehicle${uniqueVehicleLocations(userVehicle, 2)}'
        'EmptyVehiclePlaceholder'
      `
    case 3:
      return `
        'ActiveVehicle'
        'Vehicle${uniqueVehicleLocations(userVehicle, 2)}'
        'Vehicle${uniqueVehicleLocations(userVehicle, 3)}'
        'EmptyVehiclePlaceholder'
      `
    default:
      return `${dynamicVehicleLocationsLaptopMobile(noOfVehicles, userVehicle)}`
  }
}

export const isShowVehiclePlaceholder = noOfVehicles => (noOfVehicles && noOfVehicles >= 1)
